getScreenTypeByNodeContentType